/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { Colors } from '@zapier/theme';

import { Price } from '@zapier/design-system-revenue/src/components/other';
import { Interval } from '@zapier/design-system-revenue/src/types';

export type InvoiceLineItem = {
  amount: number;
  description?: string;
  id: string;
};

export type InvoiceLineSubscription = {
  amount: number;
  id: string;
  plan?: {
    interval: Interval;
    name: string;
  };
};

type Props = {
  line: InvoiceLineItem | InvoiceLineSubscription;
};

const itemCss = css`
  color: ${Colors.batmobile};
  display: flex;

  & + & {
    margin-top: 10px;

    @media (min-width: 750px) {
      margin-top: 10px;
    }
  }
`;

const descriptionCss = css`
  flex: 1 0 0;
  padding-right: 20px;
`;

const priceCss = (isRefund: boolean) => css`
  color: ${isRefund ? Colors.viper : 'inherit'};
  flex: 0 0 90px;
  text-align: right;
  white-space: nowrap;
`;

export const InvoiceLine = ({ line }: Props) => {
  // for the Backend, a negative price means a refund...
  const isRefund = line.amount < 0;

  // some invoice items dont come with a description (e.g. subscription items)
  let description;
  if ('description' in line) {
    description = line.description;
  } else if ('plan' in line) {
    description = line.plan && `${line.plan.name} (${line.plan.interval}ly)`;
  }

  return (
    <div css={itemCss}>
      <span css={descriptionCss}>{description}</span>
      <span css={priceCss(isRefund)}>
        <Price>{line.amount}</Price>
      </span>
    </div>
  );
};
